<template>
  <CForm @submit="submit">
    <CModal :title="$t('jobs.settings')" @close="close">
      <template #body>
        <CField type="radio" v-model="selection" :options="enumValues(PriceDisplayOption)" :label="$t('jobs.price')">
          <template #option="{option}">
            {{ $t(getOptionTerm(option)) }}
          </template>
        </CField>
      </template>
    </CModal>
  </CForm>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import CModal from '@/general/components/CModal.vue';
  import { BasicModalResult, MODAL_CANCELLED } from '@/general/utils/Modal';
  import CField from '@/shared/components/form/CField.vue';
  import CForm from '@/shared/components/form/CForm.vue';
  import { enumValues } from '@/shared/utils/typescript';
  import PriceDisplayOption from '../constants/PriceDisplayOption';

  const props = defineProps<{
    value: PriceDisplayOption;
  }>();

  const emit = defineEmits<{ (e: 'close', value?: PriceDisplayOption | BasicModalResult): void }>();

  const selection = ref(props.value);

  function getOptionTerm(option: PriceDisplayOption): string {
    switch (option) {
      case PriceDisplayOption.HIDDEN:
        return 'price.hide';
      case PriceDisplayOption.WITH_VAT:
        return 'price.withVat';
      case PriceDisplayOption.WITHOUT_VAT:
        return 'price.withoutVat';
    }
  }

  function submit() {
    emit('close', selection.value);
  }

  function close() {
    emit('close', MODAL_CANCELLED);
  }
</script>